<div class="trinka_cloud_wrap">
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>표절 검사</h1>
                        <h2>표절을 방지하고 <span>AI 생성</span> 콘텐츠를 탐지합니다</h2>
                        <ul class="highted-points">
                            <li>탁월한 신뢰도를 자랑하는 iThenticate 보고서를 사용해 유료 출판물에 대한 표절률 검사를 실시합니다.</li>
                            <li>모든 문서에서 AI 생성 콘텐츠의 존재 여부를 탐지합니다.</li>
                            <li>무료 표절 점수와 탐지된 출처 개요를 받아보세요.</li>
                        </ul>
                        <a href="https://cloud.trinka.ai/signup" id="autoEditGetStart" target="_blank">시작하기</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="mainSliderSection text-center">
                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../../../assets/images/plagiarism-check/plagiarism-check.jpg">
                            <source src="../../../../../assets/images/plagiarism-check/plagiarism-check.mp4#t=0.1" type="video/mp4">
                            Your browser does not support the video element. Kindly update it to latest version.
                        </video>
                        <button class="icon-pause" (click)="playPause()" [ngClass]="video_pause ? 'icon-play' : 'icon-pause'"> </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg trustedby">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3>글로벌 리더들의 신뢰</h3>
            </div>
            <div class="col-12">
                <div id="client-logos_white" class="owl-carousel">
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/elsevier.svg" class="filter" alt="elsevier">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mit.svg" class="filter" alt="mit">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/IEEE.svg" class="filter" alt="IEEE">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/stanford.svg"  class="filter" alt="standord">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/wiley.svg" class="filter" alt="wiley">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/harvard-white.svg" alt="harvard">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/caltech.svg" class="filter" alt="caltech">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/mu.svg" class="filter" alt="mu">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/polyglots.png" class="img-fluid" alt="polyglots">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/pfizer.svg" class="filter" alt="pfizer">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/abbott.svg" class="filter" alt="abbott">
                        </div>
                    </div>
                    <div class="item">
                        <div class="clientLogo">
                            <img src="../../../../assets/images/plagiarism-check/clients/princeton-white.svg" alt="princeton">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="writing_need_sections section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>나에게 가장 적합한 표절 검사를 찾아보세요</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>출처/기능</th>
                                    <th>
                                        무료 점수
                                        <p class="powered-by"><span>제공:</span> <img src="../../../../../assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                    <th>기본 표절 검사
                                    </th>
                                    <th>고급 표절 검사
                                        <p class="powered-by"><span>제공:</span> <img src="../../../../../assets/images/plagiarism-check/iThenticate_logo.svg" class="iThenticate-logo" width="90" alt="iThenticate" /></p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI 생성 콘텐츠 탐지기 <span class="newbadge">신규</span></td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>8,900만+ 건의 유료 학술 논문</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>990억+ 개의 현재 보관된 웹페이지</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2억+ 건의 오픈 액세스 논문</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>1억 200만+ 개 페이지 매일 크롤링 및 업데이트</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                                <tr>
                                    <td>다운로드 가능한 PDF를 포함한 대화형 보고서</td>
                                    <td>-</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>기본 표절 검사의 유사도 보고서에 무제한 액세스하세요 <span>Trinka Premium Plus</span></h3>
                    <a [routerLink]="['/pricing']" routerLinkActive="active" class="btn-outline-enago">
                        <span>자세히 알아보기</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="plagCheckKeyFeatures section-lg">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>주요 기능</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="tabs-wrap">
                    <ul class="nav nav-pills" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="pill" href="#freeScore">
                                <span>무료 점수</span>
                                <div class="poweredBy">
                                    <img src="../../../../assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="pill" href="#standardPlagiarism">
                                <span>기본 표절 검사</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " data-toggle="pill" href="#advancedPlagiarism">
                                <span>고급 표절 검사</span>
                                <div class="poweredBy">
                                    <img src="../../../../assets/images/plagiarism-check/iThenticate_logo.svg" width="115" class="iThenticate-logo" alt="iThenticate_logo" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div id="freeScore" class="tab-pane active">
                        <div class="pc-para">
                            <span>인터넷 출처 확인 및 AI 생성 콘텐츠 감지</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_free" class="accordion">
                                        <div class="card" [ngClass]="freeshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="freeScore(1)" data-toggle="collapse" href="#freecollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    일치율이 가장 높은 출처 3개
                                                </a>
                                            </div>
                                            <div id="freecollapseOne" class="collapse show" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>일치율이 높은 출처를 순서대로 일치율과 함께 목록으로 보여드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(2)" data-toggle="collapse" href="#freecollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    전체 유사도 점수 표시
                                                </a>
                                            </div>
                                            <div id="freecollapseTwo" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>문서에서 탐지된 표절 문제에 따라 콘텐츠 유사도 점수를 매깁니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="freeshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="freeScore(3)" data-toggle="collapse" href="#freecollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    인터넷 일치 및 유료 출판물 일치 점수
                                                </a>
                                            </div>
                                            <div id="freecollapseThree" class="collapse" data-parent="#accordion_free">
                                                <div class="card-body">
                                                    <p>문서에서 인터넷 및 유료 출처에 대한 개별 점수를 보여드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="freeshowTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/matching-scroe.svg" alt="matching-score" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-score.svg" alt="overall-score" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="freeshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/overall-paid.svg" alt="overall-paid" class="flags hidden" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="standardPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>인터넷 출처 확인 및 AI 생성 콘텐츠 감지</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion_standard" class="accordion">
                                        <!-- <div class="card" [ngClass]="standardshowTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(1)" data-toggle="collapse" href="#standardcollapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/cpu-charge.svg" alt="icon" /></span>
                                                    AI 생성 콘텐츠 탐지기
                                                </a>
                                            </div>
                                            <div id="standardcollapseOne" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>ChatGPT와 같은 대규모 언어 모델에서 생성된 콘텐츠를 탐지합니다.</p>
                                                </div>
                                            </div>
                                        </div> -->
                                      
                                        <div class="card" [ngClass]="standardshowTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="standardPlagiarism(2)" data-toggle="collapse" href="#standardcollapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    일치율 높은 출처 식별
                                                </a>
                                            </div>
                                            <div id="standardcollapseTwo" class="collapse show" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>일치율이 높은 출처를 순서대로 일치율과 함께 목록으로 보여드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="standardshowTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(3)" data-toggle="collapse" href="#standardcollapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    일치 텍스트 강조 표시
                                                </a>
                                            </div>
                                            <div id="standardcollapseThree" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>일치하는 출처의 경우, 정확히 일치하는 텍스트를 보고서에서 강조 표시하여 보여드립니다.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(4)" data-toggle="collapse" href="#standardcollapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    숨겨진 콘텐츠 플래그
                                                </a>
                                            </div>
                                            <div id="standardcollapseFour" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>문서에서 숨겨진 텍스트와 의심스러운 문자를 탐지하여 플래그를 지정합니다.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="standardshowTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="standardPlagiarism(5)" data-toggle="collapse" href="#standardcollapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    선택 섹션 제외
                                                </a>
                                            </div>
                                            <div id="standardcollapseFive" class="collapse" data-parent="#accordion_standard">
                                                <div class="card-body">
                                                    <p>선택한 섹션을 문서 검사 범위에서 제외할 수 있도록 하여 유연성을 제공해 드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="c-card key-features-right">
                                    <div class="image video-feature" [ngClass]="standardshowTab == 1 ? 'show' : ''">
                                        <video class="vid-video" id="myVideo" playsinline autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="../../../assets/images/videos/posters/plagiarism-check.jpg">
                                            <source src="../../../../assets/images/plagiarism-check/AI-Content-Detector.mp4#t=0.1" type="video/mp4">
                                            Your browser does not support the video element. Kindly update it to latest version.
                                        </video>
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="standardshowTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="advancedPlagiarism" class="tab-pane">
                        <div class="pc-para">
                            <span>유료 출판물 및 관련된 인터넷 소스  확인 <br/>
                                학술 논문을 위한 표절 검사 도구 추천</span>
                        </div>
                        <div class="row match-box">
                            <div class="col-lg-6">
                                <div class="c-card key-features-left">
                                    <div id="accordion" class="accordion">
                                        <div class="card" [ngClass]="showTab == 1 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="card-link" (click)="advancePlagiarism(1)" data-toggle="collapse" href="#collapseOne">
                                                    <span><img src="../../../../assets/images/plagiarism-check/sources.svg" alt="icon" /></span>
                                                    일치율 높은 출처 식별
                                                </a>
                                            </div>
                                            <div id="collapseOne" class="collapse show" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>일치율이 높은 출처를 순서대로 일치율과 함께 목록으로 보여드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 2 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(2)" data-toggle="collapse" href="#collapseTwo">
                                                    <span><img src="../../../../assets/images/plagiarism-check/text-block.svg" alt="icon" /></span>
                                                    일치 텍스트 강조 표시
                                                </a>
                                            </div>
                                            <div id="collapseTwo" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>일치하는 출처의 경우, 정확히 일치하는 텍스트를 보고서에서 강조 표시하여 보여드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div class="card" [ngClass]="showTab == 3 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(3)" data-toggle="collapse" href="#collapseThree">
                                                    <span><img src="../../../../assets/images/plagiarism-check/flag-2.svg" alt="icon" /></span>
                                                    숨겨진 콘텐츠 플래그
                                                </a>
                                            </div>
                                            <div id="collapseThree" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>문서에서 숨겨진 텍스트와 의심스러운 문자를 탐지하여 플래그를 지정합니다.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 4 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(4)" data-toggle="collapse" href="#collapseFour">
                                                    <span><img src="../../../../assets/images/plagiarism-check/export.svg" alt="icon" /></span>
                                                    선택 섹션 제외
                                                </a>
                                            </div>
                                            <div id="collapseFour" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>선택한 섹션을 문서 검사 범위에서 제외할 수 있도록 하여 유연성을 제공해 드립니다.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" [ngClass]="showTab == 5 ? 'active' : ' '">
                                            <div class="card-header">
                                                <a class="collapsed card-link" (click)="advancePlagiarism(5)" data-toggle="collapse" href="#collapseFive">
                                                    <span><img src="../../../../assets/images/plagiarism-check/share_1.svg" alt="icon" /></span>
                                                    공유 옵션 제공
                                                </a>
                                            </div>
                                            <div id="collapseFive" class="collapse" data-parent="#accordion">
                                                <div class="card-body">
                                                    <p>보고서를 원활하게 공유하도록 다양한 옵션을 제공해 드립니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 dflex">
                                <div class="c-card key-features-right">
                                    <div class="image" [ngClass]="showTab == 1 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/sources.png" alt="paid publications" class="matching sources" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 2 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/highlight.png" alt="paid publications" class="highlight" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 3 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/flags-hidden.png" alt="paid publications" class="flags hidden" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 4 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/eclude-choosen.png" alt="paid publications" class="exclude choosen" />
                                    </div>
                                    <div class="image" [ngClass]="showTab == 5 ? 'show' : ''">
                                        <img src="../../../../assets/images/plagiarism-check/share.png" alt="paid publications" class="share" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg standOut">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>트링카 표절 검사가 단연 돋보이는 이유는 무엇일까요?</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="standout-tbl">
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Trinka & <br/> Enago Reports</th>
                                    <th class="grammarly">Grammarly</th>
                                    <th class="quillbot">Quillbot</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- <tr>
                                    <td>AI 생성 콘텐츠 탐지기</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr> -->
                                <tr>
                                    <td>
                                        <p>
                                            iThenticate 보고서
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    고급 표절 검사와 함께 사용 가능
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            기본 표절 검사
                                            <span class="custom-tooltip">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 1.04164C14.9417 1.04165 18.9584 5.05831 18.9584 9.99998C18.9584 14.9416 14.9417 18.9583 10 18.9583C5.05837 18.9583 1.04171 14.9416 1.04171 9.99998C1.04171 5.05831 5.05838 1.04164 10 1.04164ZM10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 9.99998C17.7084 5.74998 14.25 2.29165 10 2.29164C5.75004 2.29164 2.29171 5.74998 2.29171 9.99998C2.29171 14.25 5.75004 17.7083 10 17.7083Z" fill="#414E62"/>
                                                    <path d="M10 8.54165C10.3417 8.54165 10.625 8.82498 10.625 9.16665L10.625 13.3333C10.625 13.675 10.3417 13.9583 10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333L9.375 9.16665C9.375 8.82498 9.65833 8.54165 10 8.54165Z" fill="#414E62"/>
                                                    <path d="M10 5.83335C10.1084 5.83335 10.2167 5.85835 10.3167 5.90002C10.4167 5.94168 10.5084 6.00002 10.5917 6.07502C10.6667 6.15835 10.725 6.24168 10.7667 6.35002C10.8084 6.45002 10.8334 6.55835 10.8334 6.66668C10.8334 6.77502 10.8084 6.88335 10.7667 6.98335C10.725 7.08335 10.6667 7.17502 10.5917 7.25835C10.5084 7.33335 10.4167 7.39168 10.3167 7.43335C10.1167 7.51668 9.88337 7.51668 9.68337 7.43335C9.58337 7.39168 9.49171 7.33335 9.40837 7.25835C9.33337 7.17502 9.27504 7.08335 9.23337 6.98335C9.19171 6.88335 9.16671 6.77502 9.16671 6.66668C9.16671 6.55835 9.19171 6.45002 9.23337 6.35002C9.27504 6.24168 9.33337 6.15835 9.40837 6.07502C9.49171 6.00002 9.58337 5.94168 9.68337 5.90002C9.78337 5.85835 9.89171 5.83335 10 5.83335Z" fill="#414E62"/>
                                                </svg>
                                                <div class="custom-tooltip-content custom-tooltip-transform">
                                                    기본 표절 검사와 함께 사용 가능
                                                </div>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>유사도 보고서 무제한 액세스</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>20 페이지/월</td>
                                </tr>
                                <tr>
                                    <td>다운로드 가능한 PDF 보고서</td>
                                    <td>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.6091 8.40053C28.1299 8.92123 28.1299 9.76545 27.6091 10.2862L14.2758 23.6195C13.7551 24.1402 12.9109 24.1402 12.3902 23.6195L5.72353 16.9528C5.20283 16.4321 5.20283 15.5879 5.72353 15.0672C6.24423 14.5465 7.08845 14.5465 7.60915 15.0672L13.333 20.7911L25.7235 8.40053C26.2442 7.87983 27.0885 7.87983 27.6091 8.40053Z" fill="#1E2938"/>
                                        </svg>
                                    </td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="single-wrapper section-md">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="wrap-content">
                    <h3>트링카로 <span>iThenticate 점수를 월 최대 2회</span> 무료로 확인해 보세요</h3>
                    <a href="https://cloud.trinka.ai/signup" class="btn-outline-enago" target="_blank">
                        <span>시작하기</span> <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M12.5248 15.6833C12.3664 15.6833 12.2081 15.625 12.0831 15.5C11.8414 15.2583 11.8414 14.8583 12.0831 14.6166L16.6998 9.99998L12.0831 5.38331C11.8414 5.14164 11.8414 4.74164 12.0831 4.49998C12.3248 4.25831 12.7248 4.25831 12.9664 4.49998L18.0248 9.55831C18.2664 9.79998 18.2664 10.2 18.0248 10.4416L12.9664 15.5C12.8414 15.625 12.6831 15.6833 12.5248 15.6833Z" fill="black"/>
                            <path d="M17.4415 10.625H3.4165C3.07484 10.625 2.7915 10.3417 2.7915 10C2.7915 9.65833 3.07484 9.375 3.4165 9.375H17.4415C17.7832 9.375 18.0665 9.65833 18.0665 10C18.0665 10.3417 17.7832 10.625 17.4415 10.625Z" fill="black"/>
                          </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-xl-5 col-md-12">
                <div class="section-tl">
                    <h2>1700+ 개의 유료 과학 저널을 망라합니다</h2>
                    <div class="HeadingSubLine"></div>
                    <p>가장 정확한 텍스트 유사도 탐지 알고리즘을 활용해 콘텐츠의 표절 여부를 확인하고 콘텐츠의 무결성과 신뢰성을 유지하세요. 나의 작업물을 Elsevier, Wiley, Springer Nature, Taylor & Francis, Sage를 비롯하여 수많은 저명한 출판사에서 출판한 논문과 비교해 보세요.</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-6 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-map.png" alt="plag check map" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-lg pt-0">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-tl">
                    <h2>트링카 표절 검사로 최고 품질의 평가를 받아보세요</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xl-6 col-md-12">
                <div class="section-tl">
                    <p>이용 가능한 논문 표절 검사기가 다양하기에 올바른 도구를 선택하기가 어려울 수 있습니다. 보다 수월한 선택에 도움을 드리고자 널리 사용되는 여러 표절 검사기를 비교해 본 결과, 트링카가 가장 신뢰할 수 있고 정확한 결과를 제공했습니다.</p>
                    <p>표절률이 높은 샘플 논문 문서로 테스트를 진행했을 때, 트링카 표절 검사는 다른 대부분의 도구보다 뛰어난 성능을 보였습니다.</p>
                    <p>정확도, 데이터베이스 규모, 접근성, 사용 편의성, 비용 및 보안이라는 6가지 매개변수를 기준으로 하여 3개의 주요 도구를 비교했습니다. 트링카는 데이터를 안전하게 보호하는 가운데 최고 수준의 평가와 전문 지식을 제공해 드립니다.</p>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 offset-xl-1  col-md-12">
                <div class="no-image">
                    <img src="../../../../assets/images/plagiarism-check/plagiarism-check-graph.jpg" alt="plag check graph" class="img-fluid" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="suitableForSection section-lg" style="background-color: #F5F7F8;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-tl">
                    <h2>왜 트링카 표절 검사를 선택해야 할까요?</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/languageScore_icon.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>매달 표절 검사 무료 점수 제공</h4>
                        <p>보고서를 생성하기 전에, 콘텐츠의 표절 여부를 무료로 확인해 보세요. 인터넷, 오픈 액세스, 유료 출판물 전반에 걸쳐 문서의 표절 여부를 검사해 드립니다.</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/ai-content-detector.svg" width="40" height="40" alt="ppc"/>
                    </div>
                    <div class="media-body">
                        <h4>AI 생성 콘텐츠 탐지</h4>
                        <p>ChatGPT, GPT-4, Bard, Bing Chat과 같은 모든 대규모 언어 모델(LLM)에서 표절 여부를 즉시 확인하고 동시에 AI 생성 콘텐츠를 탐지하여 콘텐츠 무결성을 보호해 드립니다.</p>
                    </div>
                </div>
            </div> -->
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/standard-check.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>무제한 기본 표절 검사</h4>
                        <p>제공하는 기본 표절 검사(시뮬레이션 검사)에 무제한으로 액세스하여 내 콘텐츠를 인터넷 출처 및 오픈 액세스 출판물과 비교 검사해 보세요.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 dflex">
                <div class="media">
                    <div class="media-left">
                        <img src="../../../assets/images/plagiarism-check/detection-technology.svg" width="40" height="40" alt="ppc"/>

                    </div>
                    <div class="media-body">
                        <h4>탁월한 탐지 기술</h4>
                        <p>내로라 하는 대형 학술 출판사들이 사용하고 있는 당사의 표절 검사 탐지 기술은 인용된 콘텐츠를 지능적으로 배제하여 신뢰할 수 있는 결과를 제공해 드립니다.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="allAboutTrinkaCredit">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="aboutTrinkaCreditHeading">
                    <h2>표절 검사는 크레딧을 사용합니다</h2>
                    <div class="HeadingSubLine"></div>
                </div>
                <div class="creditSectionFeature">
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">크레딧은 트링카의 다양한 기능을 필요에 따라 사용하도록 해드리는 토큰과 같습니다.</p>
                        <p>프리미엄 요금제는 월 10크레딧, 기본 요금제는는 월 4크레딧을 무료로 제공해 드립니다. 자세히 알아보려면 여기를 <a [routerLink]="['/features/credits']">클릭하세요</a>.</p>
                    </div>
                    <div class="featurePointsCredits">
                        <span>
                            <img src="../../../../assets/images/credits_icon.png" alt="credits">
                        </span>
                        <p>기본 표절 검사는 12크레딧을, 고급 표절 검사는 18크레딧을 사용합니다.<br />매달 제공되는 무료 크레딧을 사용하다가 필요할 때만 크레딧을 추가 구매하시면 됩니다.</p>
                    </div>
                    <div class="othersPointsForCredits">
                        <p style="margin-bottom: 0px;">트링카 프리미엄 사용자는 표절 점수를 월 2회 무료로 확인하실 수 있습니다.</p>
                        <p>또한 크레딧 팩 구매 시 최대 40% 할인을 받으실 수 있습니다.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-lg bg-grey">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="section-tl">
                    <h2>시작하는 방법</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="allPlans-wrapper">
                    <div class="plan-content plan-simple">
                        <div class="plan-header"></div>
                        <ul>
                            <li>무료 점수</li>
                            <li>일반 보고서 </li>
                            <li>어드밴스 보고서</li>
                            <li>매달 새로 크레딧 잔고 제공 </li>
                            <!-- <li>Additional Credit Discounting / Purchase</li> -->
                            <li>크레딧 대량구매 비용</li>
                        </ul>
                    </div>
                    <div class="plan-content plan-basic">
                        <div class="plan-header">
                            기본
                        </div>
                        <ul>
                            <li><span>무료 점수 확인 월 1회</span></li>
                            <li><span>이용가 <b>12크레딧 </b></span></li>
                            <li><span>이용가 <b>18크레딧</b></span></li>
                            <li><span>4크레딧월</span></li>
                            <!-- <li><span><b>6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>크레딧 당 <b class="d-inline"> 3 USD</b><br/> ( 40크레딧 팩)</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-premium">
                        <div class="plan-header">
                            프리미엄
                        </div>
                        <ul>
                            <li><span>무료 점수 확인월 2회</span></li>
                            <li><span>이용가 <b>12크레딧 </b></span></li>
                            <li><span>이용가 <b>18크레딧</b></span></li>
                            <li><span>10크레딧월</span></li>
                            <!-- <li><span><b>3.6 USD</b> per Extra Credit Purchase</span></li> -->
                            <li><span>크래딧 당<b class="d-inline">1.8 USD </b><br/> ( 40크레딧 팩)</span></li>
                        </ul>
                    </div>
                    <div class="plan-content plan-recommended">
                        <div class="plan-header">
                            프리미엄 플러스
                            <span>추천</span>
                        </div>
                        <ul>
                            <li><span>무료 점수 확인월 2회</span></li>
                            <li><span><b>무제한 액세스 </b></span></li>
                            <li><span>이용가 <b>18크레딧</b></span></li>
                            <li><span>10크레딧월</span></li>
                            <!-- <li><span><b>3.6 USD </b> per Extra Credit Purchase</span></li> -->
                            <li><span>크래딧 당<b class="d-inline">1.8 USD </b><br/> ( 40크레딧 팩)</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="use_trinka_other_app accomplishBrilliantWrap">
    <div class="container">
        <div class="accomplishBrilliantSection">
            <h2>논문 표절은 피하고 퀄리티 높은 원고로 제출해 보세요 </h2>
            <a href="https://cloud.trinka.ai/signup" target="_blank">시작하기</a>
        </div>
    </div>
</div>

<div class="pricingQuestionAnwser" #target>
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="pricingHeadingQuestion">
                    <h2>자주하는 질문</h2>
                    <div class="HeadingSubLine"></div>
                </div>
            </div>
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <div class="pricingQuestionsList">
                    <div class="accordion" id="faq">
                        <div class="card">
                            <div class="card-header" id="QuestionOne">
                                <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                    트링카의 표절 검사는 어떻게 사용할 수 있나요?</a>
                            </div>

                            <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                <div class="card-body">
                                    <h4>사용 방법은 간단합니다!</h4>
                                    <ol>
                                        <li> 트링카 클라우드 계정으로 이동합니다(아직 무료 계정에 가입하지 않으셨나요? 지금 <a href="https://cloud.trinka.ai/signup" target="_blank">가입하세요!</a> )</li>
                                        <li><b>오른쪽 패널에서 표절 검사 페이지를 클릭</b>하여 이동합니다.</li>
                                        <li>문서를 업로드하고, 나에게 적합한 검사를 선택합니다. 트링카 드라이브에 이미 업로드한 상태인 파일도 선택 가능합니다.</li>
                                        <li>몇 분 안에 상세 보고서를 받아보세요!</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="QuestionTwo">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                    aria-controls="QuestionTwoContent">
                                    트링카 표절 검사는 타사 표절 검사와 어떤 차이가 있나요?</a>
                            </div>

                            <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                <div class="card-body">
                                    <p>다른 도구와 달리, 트링카를 사용하면 필요에 따른 표절 검사를 선택할 수 있습니다. 예컨대 인터넷 콘텐츠만 선택하거나, 인터넷 콘텐츠 및 유료 출판물을 선택할 수 있습니다. 턴잇인(iThenticate)과 파트너십을 맺은 트링카의 기술은 전 세계 대형 학술 출판사가 신뢰하는 탁월한 탐지 기술을 제공해 드립니다.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionThree">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                    aria-controls="QuestionThreeContent">
                                    트링카의 표절 검사를 무료로 사용할 수 있나요?
                                </a>
                            </div>

                            <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                <div class="card-body">
                                    <!-- <p>Yes. All Basic users get 1 free Plagiarism Score every month. All Premium users get 2 free Plagiarism Score checks every month. You can run as many checks as you like with <a [routerLink]="['/features/credits']">credits</a>.</p> -->
                                    <p>트링카에서 표절 점수를 무료로 확인하실 수 있습니다!</p>
                                    <p>베이직 계정이 있으면 표절 점수를 월 1회 무료로 확인하실 수 있습니다. 트링카 프리미엄 계정이 있으면 표절 점수를 월 2회 무료로 확인하실 수 있습니다.</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="QuestionFour">
                                <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                    aria-controls="QuestionFourContent">
                                    표절 검사 보고서를 다운로드할 수 있나요?
                                </a>
                            </div>

                            <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                <div class="card-body">
                                    <p>그렇습니다! 보고서는 PDF로 제공되며, 생성한 보고서는 언제든지 다운로드하실 수 있습니다.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-1"></div>
        </div>
    </div>
</div>
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/Mc_EZXIzvFU"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal" id="freePlagiarismScore">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header bb-none">
          <h4 class="modal-title">Sample Score</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          <img src="../../../../assets/images/reports/report_list_item.png" alt="plag check report" class="img-fluid" />
        </div>
      </div>
    </div>
</div>